import React from 'react'
import apple from '../assets/images/getappimg/1.svg'
import android from '../assets/images/getappimg/2.svg'

// App-store badges shown on the landing page ("Get Access From Anywhere")
// and in the footer. Android is live, so it comes first and links to the
// Play Store listing (package id = applicationId in the app's
// android/app/build.gradle). The iOS app isn't published yet, so the Apple
// badge is shown second, greyed out and not clickable.
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.harmonydaycare'

const StoreBadges = ({ width = 141, height = 44, className = '' }) => (
    <div className={`d-flex flex-wrap align-items-center gap-2 ${className}`}>
        <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            title="Get it on Google Play"
            style={{ display: 'inline-block', lineHeight: 0 }}
        >
            <img src={android} alt="Get it on Google Play" style={{ width, height, objectFit: 'fill', cursor: 'pointer' }} />
        </a>
        <span
            role="img"
            aria-label="Apple App Store - coming soon"
            title="Coming soon on the App Store"
            style={{ display: 'inline-block', lineHeight: 0, cursor: 'not-allowed' }}
        >
            <img
                src={apple}
                alt=""
                draggable={false}
                style={{ width, height, objectFit: 'fill', filter: 'grayscale(1)', opacity: 0.45, pointerEvents: 'none', userSelect: 'none' }}
            />
        </span>
    </div>
)

export default StoreBadges
